/* DON'T EDIT THIS FILE: edit original and run build again */ export const webHomeChannelType = "webHome";
export const reutersChannelType = "reuters";
export const whatsappChannelType = "whatsapp";
export const emailChannelType = "email";
